import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/meal"; // API URL untuk meal

  // State untuk data form, diinisialisasi untuk mode create atau update
  const [formData, setFormData] = useState({
    name: "", // Nama Meal
  });

  const isUpdateMode = !!initialData; // Cek apakah dalam mode update

  // API hook untuk create dan update
  const { createData: createMeal, loading: creatingMeal } =
    useCreateData(API_URL, "meals");
  const { updateData: updateMeal, loading: updatingMeal } =
    useUpdateData(`${API_URL}/${initialData?.id}`, "meals");

  // Handle perubahan data form
  const handleChange = useFormChangeHandler(setFormData);

  // Handle submit form
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateMeal : createMeal,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    // Jika initial data disediakan (untuk update), isi form
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        accountNumber: initialData.accountNumber || "",
        accountName: initialData.accountName || "",
      });
    }
  }, [initialData]);

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Nama Meal */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Nama:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Nama Meal"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              minLength={3}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>
      </div>

      {/* Tombol Submit */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode
            ? "Update Meal"
            : "Create Meal"}
        </button>
      </div>
    </form>
  );
};

export default CreatePage;
